/**
 * Copyright (c) 2021 - 2023, Kodit Doo
 * Created by kodit-marko on 09.02.2023.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { SefClient } from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { DialogSize } from '../../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { DocumentPreviewService } from '../../../../../../services/src/lib/document-preview.service';

@Component({
  selector: 'kodit-neobradjen-racun-files-form',
  templateUrl: './neobradjen-racun-files-form.html',
  styleUrls: ['./neobradjen-racun-files-form.scss'],
})
export class NeobradjenRacunFilesFormComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  dokumentList: any[] = [];
  maxRows: number = 10;

  /** Configs */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.MEDIUM
  );

  /** I/O */

  constructor(
    private _dialogService: DynamicDialogService,
    private _dialogConfig: DynamicDialogConfig,
    private _client: SefClient,
    private _docPreviewService: DocumentPreviewService,
  ) {}

  ngOnInit() {
    this._load();
  }

  handlePreview(fileUrl: string) {
    this._docPreviewService.openDialogForPresignedUrl(fileUrl);
  }

  private _load() {
    this._subs.add(
      this._client
        .getSefRacunRelevantniDokumentList(this._dialogConfig.data.sefId)
        .subscribe((res) => {
          this.dokumentList = res.data;
          console.log(this.dokumentList);
        })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
